define( [
	"../core",
	"../selector",
	"../effects"
], function( jQuery ) {

jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/effects/animatedSelector.js
// module id = 162
// module chunks = 0